import { render, staticRenderFns } from "./DemandeAdmissionPRP.vue?vue&type=template&id=627cb886"
import script from "./DemandeAdmissionPRP.vue?vue&type=script&lang=js"
export * from "./DemandeAdmissionPRP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports